/**
 * 首页各区块 CTA 跳转（与智能体中心 ?nav= 约定一致）
 */
export const WORKFLOW_STORE = '/workflow-store'

export const agentsNav = (nav) => ({
  path: '/agents-center',
  query: { nav },
})

export const AGENTS_PLAZA = agentsNav('plaza')
export const AGENTS_WRITING = agentsNav('writing')
export const AGENTS_ASSISTANT = agentsNav('assistant')
export const AGENTS_APPS = agentsNav('apps')
export const AGENTS_DISCOVER = agentsNav('discover')
